import AdvancedDestinationResults from './advanced-destination-results';
import AdvancedDestinationSelector from './advanced-destination-selector';

export default class AdvancedDestinationSelectorV2 extends AdvancedDestinationSelector {
    constructor(form, destinationCodeInput) {
        super(form, destinationCodeInput);
        this._visibleClass = 'roi-search-engine__destination-dropdown--visible';
        this._destinationTabs = {
            noResultsItemClass: 'roi-search-engine__destination-results-item--no-results',
            resultItemClass: 'roi-search-engine__destination-results-item',
            resultItemSubtitleClass: 'roi-search-engine__destination-results-item__subtitle',
            selectAll: 'js-roi-search-engine-destination-select-all',
            tabsSelector: false
        };
        this._closeButton = this._container.querySelector('.js-roi-search-engine-destination-close');
        this._destinationResults = new AdvancedDestinationResults(
            this, this._container, this._destinationTabs
        );
        this._coddestino = document.getElementById('id_coddestino-widget-0');
        this._engineSearch = document.querySelector('.js-roi-search-engine');

        this._mainInput.addEventListener('input', () => {
            this.filterOptions();
        });

        this._mainInput.addEventListener('focus', () => {
            this.filterOptions();
        });

        if (this._closeButton) {
            this._closeButton.addEventListener('click', () => {
                this._close();
            });
        }
        this._listenToClickOutsideDropdown();
    }

    _close() {
        this._container.classList.remove(this._visibleClass);
        this._form.querySelector('.js-roicalendar-trigger').focus();
    }

    _initContainer() {
        let container = this._form.querySelector('.js-roi-search-engine-destination-selector');
        const destinationContainer = this._form.querySelector('.roi-search-engine__item--destination');
        if (container === null) {
            throw Error('Advanced destination selector not found');
        }

        container = container.parentNode.removeChild(container);
        destinationContainer.appendChild(container);
        return container;
    }

    _clearInput() {
        const clearButton = this._container.querySelector(
            '.js-roi-search-engine-destination-clear'
        );

        if (clearButton) {
            clearButton.addEventListener('click', () => {
                this._mainInput.value = '';
                this._coddestino.value = '';
                this.filterOptions();
                this._mainInput.focus();
            });
        }
    }

    filterOptions(openFlag = false) {
        this._clear();
        let enteredTextArray = [],
            enteredText = this._mainInput.value,
            choices;

        if (this._coddestino.value.indexOf(',') !== -1) {
            enteredTextArray = this._coddestino.value.split(',');
        }

        if (enteredText === '' || openFlag) {
            if (enteredText === '') {
                this._coddestino.value = '';
            }
            choices = { ...this._destinations };
        } else if (enteredTextArray.length) {
            choices = {};
            Object.keys(this._destinations).forEach((key) => {
                enteredTextArray.forEach((coddestino) => {
                    coddestino = this.constructor._sanitizeString(coddestino);
                    enteredText = this.constructor._sanitizeString(enteredText);
                    if (!choices[key]) {
                        choices[key] = [];
                    }
                    if (key === 'hotels') {
                        choices[key].push(this._destinations[key].find(item => item.searchText.includes(coddestino)));
                    } else {
                        choices[key] = this._destinations[key].filter((item) => {
                            const searchTextMatch = item.searchText.includes(enteredText),
                                interestPointsMatch = item.interestPointNames.some(
                                    point => this.constructor._sanitizeString(point).includes(enteredText)
                                );
                            return searchTextMatch || interestPointsMatch;
                        });
                    }
                });
            });
        } else {
            enteredText = this.constructor._sanitizeString(enteredText);
            choices = {};
            Object.keys(this._destinations).forEach((key) => {
                choices[key] = this._destinations[key].filter((item) => {
                    const searchTextMatch = item.searchText.includes(enteredText),
                        interestPointsMatch = item.interestPointNames.some(
                            point => this.constructor._sanitizeString(point).includes(enteredText)
                        );
                    return searchTextMatch || interestPointsMatch;
                });
            });
        }
        this._populateContainer(choices);
        this._mainInput.value = this._mainInput.value
            .replace(/^[\s-]+/g, '');
        this._container.classList.add(this._visibleClass);
    }

    _positionDropdown() {
        const destinationContainer = this._form.querySelector('.roi-search-engine__item--destination'),
            destinationDropdownTop = this._engineSearch.getBoundingClientRect().bottom -
        destinationContainer.getBoundingClientRect().bottom;
        if (destinationDropdownTop < 40 && destinationDropdownTop > 0) {
            this._container.style.top = `calc(100% + ${destinationDropdownTop}px)`;
        } else {
            this._container.style.top = '100%';
        }
    }

    _populateContainer(choices) {
        let index = 0;
        this._positionDropdown();
        Object.keys(choices).forEach((key) => {
            const choiceGroupContainer = this._container.querySelector(
                    `${this._resultsListSelector}[data-key=${key}]`
                ),
                groupChoices = choices[key];
            let results;
            if (groupChoices.length === 0) {
                results = this._destinationResults.createNoResultsMessage();
            } else {
                [results, index] = this._getSortedResults(groupChoices, index);
            }
            if (choiceGroupContainer != null) {
                choiceGroupContainer.appendChild(results);
            }
        });
        this._destinationResults.listenToResultsEvents();
    }

    _listenToClickOutsideDropdown() {
        document.addEventListener('click', (event) => {
            const { target } = event;
            if (!this._container.contains(target) &&
                !this._mainInput.contains(target)) {
                this._container.classList.remove(this._visibleClass);
            }
        });
    }

    _formatDestinations(destinations) {
        const results = {
                destinations: [],
                hotels: [],
                interest_points: []
            },
            hasSubtitle = this._container.dataset.destinationWithSubtitle;
        this._hotelTrans = this._container.dataset.transHotel;
        this._hotelsTrans = this._container.dataset.transHotels;

        destinations.forEach((city) => {
            this._cityName = false;
            this._isHotel = false;
            results.destinations.push(this._formatCity(city, hasSubtitle));
            city.hotels.forEach((hotel) => {
                results.hotels.push(this._formatHotel(hotel, city, hasSubtitle));
            });
            city.interest_points.forEach((interestPoint) => {
                results.interest_points.push(this._formatInterestPoint(interestPoint, city));
            });
        });
        return results;
    }

    _formatCity(city, subtitle) {
        if (subtitle !== undefined) {
            this._cityName = city.hotels.length === 1
                ? `1 ${this._hotelTrans}`
                : `${city.hotels.length} ${this._hotelsTrans}`;
        }

        const formatItem = this._formatItem(city.name, city.code, `${city.code} - ${city.name}`);

        return this.constructor._addInterestPointNamesToItem(
            city.interest_points,
            formatItem
        );
    }

    _formatHotel(hotel, city, subtitle) {
        const hasCategory = this._container.dataset.destinationWithCategory;
        this._isHotel = true;
        if (subtitle !== undefined) {
            this._cityName = city.name;
        }

        if (hasCategory !== undefined) {
            this._hotelCategory = hotel[2]; // eslint-disable-line
        }

        const formatItem = this._formatItem(
            hotel[1],
            hotel[0],
            `${city.code} - ${city.name} - ${hotel[0]} - ${hotel[1]}`,
        );

        return this.constructor._addInterestPointNamesToItem(
            hotel[3],
            formatItem
        );
    }

    _formatInterestPoint(interestPoint, city) {
        this._isHotel = false;
        this._hotelCategory = null;

        const formatItem = this._formatItem(
            interestPoint[0],
            interestPoint[1],
            `${city.code} - ${city.name} - ${interestPoint[0]}`,
        );
        return this.constructor._addInterestPointNamesToItem(
            [],
            formatItem
        );
    }

    static _addInterestPointNamesToItem(interestPointList, formatItem) {
        const interestPointNames = [];
        interestPointList.forEach((interestPoint) => {
            interestPointNames.push(interestPoint[0]);
        });
        formatItem.interestPointNames = interestPointNames;
        return formatItem;
    }
}
